export default "__VITE_ASSET__Bzm_4pRN__"